<template>
  <modal :showModal="showModal" id="modal-user" @close="close">
    <template slot="modal-header">
      <h5 class="bold">Szczegóły użytkownika</h5>
    </template>

    <template slot="modal-body" v-if="account.payments_info">
      <div class="col s12 left-align" v-if="account.payments_info.account_type !== 'company'">
        <h5>Dane użytkownika:</h5>
        <div>Imię i nazwisko: <b>{{ account.first_name }} {{ account.last_name }}</b></div>
        <div>Pesel: <b>{{ account.payments_info.pesel }}</b></div>
        <div>Telefon: <a :href="'tel:' + account.phone">{{ account.phone }}</a></div>
        <div>E-mail: <a :href="'mailto:' + account.email">{{ account.email }}</a></div>
      </div>
      <div class="col s12 left-align" v-if="account.payments_info.account_type === 'company'">
        <h5>Dane firmy:</h5>
        <div>Nazwa: <b>{{ account.payments_info.company_name }}</b></div>
        <div>NIP: <b>{{ account.payments_info.nip }}</b></div>
        <div>Imię i nazwisko: <b>{{ account.first_name }} {{ account.last_name }}</b></div>
        <div>Telefon: <a :href="'tel:' + account.phone">{{ account.phone }}</a></div>
        <div>E-mail: <a :href="'mailto:' + account.email">{{ account.email }}</a></div>
      </div>
      <div class="col s12 left-align">
        <h5>Model rozliczeniowy</h5>
        <ul class="browser-default">
          <li v-if="account.settlement.cps">CPS: <b>{{ account.settlement.cps | currency }}</b></li>
          <li v-if="account.settlement.cpl">CPL: <b>{{ account.settlement.cpl | currency }}</b></li>
        </ul>
      </div>

      <div class="col s12 left-align" id="promotion-scope">
        <h5>Sposób promocji</h5>
        <ul class="browser-default">
          <li v-if="account.website">strona internetowa: {{ account.website_url }}</li>
          <li v-if="account.social_media">social media</li>
          <li v-if="account.marketing">marketing</li>
          <li v-if="account.email_marketing">email marketing</li>
        </ul>
      </div>
      <div class="col s12 left-align">
        <h5>Ostatnia wypłacona transza:</h5>
        <div v-if="account.tranches_info">
          <div>Data: <b>{{ account.tranches_info.created_at | date }}</b></div>
          <div>Nr transzy: <b>{{ account.tranches_info.token }}</b></div>
          <div>Wartość: <b>{{ account.tranches_info.amount | currency }}</b></div>
        </div>
        <div v-else>brak</div>
      </div>
    </template>

    <template slot="modal-footer">
      <button class="btn btn-large btn-secondary" @click="close">
        <i class="mfind-icon-back"></i>
        Zamknij
      </button>
    </template>

    <template slot="loader">
      <Loader :loading="this.data.loading"/>
    </template>
  </modal>
</template>

<script>
import Loader from '@/components/loader'
import Modal from '@/components/modal'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters } = createNamespacedHelpers('users')
export default {
  props: ['account', 'showModal'],
  components: { Loader, Modal },
  data () {
    return {
      data: {
        loading: false,
        errors: false
      }
    }
  },
  methods: {
    close: function () {
      this.$emit('close')
    }
  },
  computed: {
    ...mapGetters([
      // 'getStatuses'
    ])
  }
}
</script>

<style lang="scss">
@import 'src/components/modal';

.token-value, .amount-value, .email-value, .status-change-value {
  margin: 5px 0;

  span {
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// modalUser.vue?62995de5